import { useMutation, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../config/Axios';
import { useCustomToast } from '../pages/Contexts/ToastContext';

const KEY = 'receiversList';

export const useGetReceivers = (params = {}, options = {}) => {
  const { showToast } = useCustomToast();
  return useQuery(
    [KEY, params],
    async ({ queryKey }) => {
      const [, p] = queryKey;
      const { data } = await axiosInstance.get('/receivers', { params: p });
      return data;
    },
    {
      keepPreviousData: true,
      onError: (err) => showToast('error', 'Receivers', err.response?.data?.message),
      ...options,
    }
  );
};

export const useGetReceiver = (id) => {
  const { showToast } = useCustomToast();
  return useQuery(
    ['receiver', id],
    async ({ queryKey }) => (await axiosInstance.get(`/receivers/${queryKey[1]}`)).data,
    {
      enabled: !!id,
      onError: (err) => showToast('error', 'Receiver', err.response?.data?.message),
    }
  );
};

export const useCreateReceiver = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((payload) => axiosInstance.post('/receivers/create', payload), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      showToast('success', 'Receivers', 'Receiver created!');
    },
    onError: (err) => showToast('error', 'Receivers', err.response?.data?.message),
  });
};

export const useUpdateReceiver = (id) => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((payload) => axiosInstance.put(`/receivers/${id}/update`, payload), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      qc.invalidateQueries(['receiver', id]);
      showToast('success', 'Receivers', 'Receiver updated!');
    },
    onError: (err) => showToast('error', 'Receivers', err.response?.data?.message),
  });
};

export const useDeleteReceiver = () => {
  const qc = useQueryClient();
  const { showToast } = useCustomToast();
  return useMutation((id) => axiosInstance.delete(`/receivers/${id}/delete`), {
    onSuccess: () => {
      qc.invalidateQueries(KEY);
      showToast('success', 'Receivers', 'Receiver removed!');
    },
    onError: (err) => showToast('error', 'Receivers', err.response?.data?.message),
  });
};
